// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://hengqdxxjqffsbjnyilf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhlbmdxZHh4anFmZnNiam55aWxmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgwMTU2NDEsImV4cCI6MjA3MzU5MTY0MX0.IaK1AtwlEuj-7doFXjVJFcE92rutcCF-b8hbFzb8-k0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
